// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './items-api';

export const useCreateItem: typeof hookExports.useCreateItem = hookExports.useCreateItem;
export const useListItems: typeof hookExports.useListItems = hookExports.useListItems;
export const useLazyListItems: typeof hookExports.useLazyListItems = hookExports.useLazyListItems;
export const useGetItem: typeof hookExports.useGetItem = hookExports.useGetItem;
export const useLazyGetItem: typeof hookExports.useLazyGetItem = hookExports.useLazyGetItem;
export const useUpdateItem: typeof hookExports.useUpdateItem = hookExports.useUpdateItem;
export const useDeleteItem: typeof hookExports.useDeleteItem = hookExports.useDeleteItem;
export const usePublishItem: typeof hookExports.usePublishItem = hookExports.usePublishItem;
export const useUnpublishItem: typeof hookExports.useUnpublishItem = hookExports.useUnpublishItem;
